/**
 * Login flow step constants
 * Used to track current step in multi-step login process
 *
 * Pentest 3.3.3: OTP / şifremi unuttum / yeni şifre adımları kaldırıldı —
 * ilgili backend uçları feature flag ile kapalı (404) ve UI'dan erişilemiyordu.
 */
export enum LoginStep {
  ROLE_SELECTION = 1,
  ADMIN_LOGIN = 2,
  STAFF_LOGIN = 3,
}

/**
 * Role selection constants
 */
export enum LoginRole {
  EMPLOYEE = 0,
  MANAGER = 1,
}
